<template>
  <TheLayout>
    <div class="custom_theo_design" v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_VIEW')">
      <!-- moi -->
      <!-- moi -->
      <div class="row">
        <div class="col-12">
          <div
            class="
              page-title-box
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <b class="fs-16 text-bold"> NHÀ CUNG CẤP</b>
          </div>
        </div>
      </div>
      <div class="tab_group_custom mb-3 d-flex align-items-center">
        <router-link to="/supplier-list" class="tab_link">Danh sách NCC</router-link>
        <span class="border"></span>
        <router-link to="/group-supplierv2" class="tab_link">Nhóm NCC</router-link>
      </div>
      <div v-show="isShow">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content=between mb-3">
                  <b-input-group class="wrapperInput">
                    <el-popover placement="bottom-start" width="530" trigger="click" v-model="showFilter">
                      <!-- slot -->
                      <div class="row d-flex align-items-center mb-3">
                        <div class="col-3 text-right">Nhóm NCC:</div>
                        <div class="col-9">
                          <el-select
                            @focus="focusNCC"
                            class="w-100"
                            v-model="groupNCCid"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="Tìm kiếm theo tên"
                            :remote-method="getListGroupNCC"
                            :loading="loadingSelect"
                          >
                            <el-option v-for="(item, i) in optionsGroupNCC" :key="i" :label="item.name" :value="item.id"> </el-option>
                          </el-select>
                        </div>
                      </div>
                      <div class="row d-flex align-items-center mb-3">
                        <div class="col-3 text-right">Phân loại:</div>
                        <div class="col-9">
                          <el-select class="w-100" v-model="isPerson" placeholder="Tất cả">
                            <el-option v-for="item in optionsIsPerson" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                          </el-select>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                          <el-button @click="showFilter = false">Hủy</el-button>
                          <el-button type="danger" plain @click="resetFilter(), fetchData()">Xóa bộ lọc</el-button>
                          <el-button type="primary" @click="searchItem">Áp dụng bộ lọc</el-button>
                        </div>
                      </div>
                      <!-- reference -->
                      <el-button style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="info" plain>
                        <div class="justify-content-center align-items-center d-flex">
                          <div><i style="font-size:24px; margin-right:4px" class="mdi mdi-filter-outline"></i></div> Bộ lọc
                        </div>
                      </el-button>
                    </el-popover>
                    <div class="search-input">
                      <el-input
                        v-model="textSearchNCC"
                        @keyup.native.enter="fetchData"
                        class="ml-2"
                        placeholder="Tìm kiếm theo tên, SĐT"
                        prefix-icon="el-icon-search"
                        style="width: 280px;"
                        clearable
                      >
                      </el-input>
                    </div>
                  </b-input-group>
                  <div class="d-flex">
                    <el-button  @click="modalImport = true" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="info" plain>
                        <div class="justify-content-center align-items-center d-flex">
                          <div><i style="font-size:24px; margin-right:4px" class="mdi mdi-import"></i></div> Nhập dữ liệu
                        </div>
                      </el-button>
                      <el-button @click.native="exportData" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="info" plain>
                        <div class="justify-content-center align-items-center d-flex">
                          <div><i style="font-size:24px; margin-right:4px" class="mdi mdi-import"></i></div> Xuất Excel
                        </div>
                      </el-button>
                    <el-button v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_CREATE')"  @click="$router.push({ path: `/supplier-list/supplier-add` })" style="padding:7px 16px 7px 12px; height: 44px" slot="reference" type="primary">
                      <div class="justify-content-center align-items-center d-flex">
                        <div><i style="font-size:18px; margin-right:4px" class="fa-solid fa-plus"></i></div> Thêm mới NCC
                      </div>
                    </el-button>
                  </div>
                </div>
                <div v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_DELETE') && selected.length > 1" class="d-flex mb-3 align-items-center">
                  <div class="text-selected-item text-bold mr-3">Đã chọn {{ selected.length }} NCC</div>
                  <el-button type="danger" plain @click="deleteItem(selected)">
                    Xóa NCC
                  </el-button>
                </div>
                <div class="responsive-table">
                  <div class="table-responsive mb-0">
                    <b-table head-variant="light" hover :items="dataSupplier" :fields="fields" tbody-tr-class="row-table-class">
                      <template #table-caption>
                        <div v-if="totalRows == 0 && filter.length == 0" class="emptyData">
                          <div class="empty_box text-center my-2">
                            <div class="empty_title mb-2">Cửa hàng của bạn chưa có nhà cung cấp</div>
                            <div class="empty_sub mb-4">
                              Thêm mới hoặc nhập file nhà cung cấp để lưu lại thông tin cá nhân, công nợ, lịch sử nhập hàng<br />
                              của nhà cung cấp đó.
                            </div>
                            <b-button
                              variant="primary"
                              v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_CREATE')"
                              @click="$router.push({ path: `/supplier-list/supplier-add` })"
                            >
                              <i class="bx bx-plus"></i>
                              Thêm mới NCC đầu tiên
                            </b-button>
                          </div>
                        </div>
                        <div v-if="totalRows == 0 && filter.length > 0" class="emptyData">
                          <p>Không tìm thấy kết quả tìm kiếm</p>
                        </div>
                      </template>

                      <template v-slot:head(selected)="data">
                        <b-form-checkbox v-model="selectAll" :value="data.item" />
                      </template>

                      <template #cell(selected)="data">
                        <b-form-group style="margin-bottom: 0px">
                          <b-form-checkbox v-model="selected" :value="data.item" />
                        </b-form-group>
                      </template>

                      <template #cell(name)="data">
                        <p
                          v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_VIEW')"
                          style="margin: 0px; white-space: nowrap"
                          class="text-primary"
                          @click="detailItem(data.item)"
                        >
                          {{ data.item.name }}
                        </p>
                      </template>

                      <template #cell(group)="data">
                        <div v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_VIEW')">
                          <p @click="detailItem(data.item)" style="margin: 0px; white-space: nowrap" v-for="(item, index) in data.item.groups" :key="index">
                            {{ item.name }}
                          </p>
                        </div>
                      </template>

                      <template #cell(isPerson)="data">
                        <p v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_VIEW')" @click="detailItem(data.item)" style="margin: 0px; white-space: nowrap">
                          {{ data.item.isPerson ? "Cá nhân" : "Doanh nghiệp" }}
                        </p>
                      </template>

                      <template #cell(phoneNo)="data">
                        <p v-if="dataPermission && dataPermission.includes('NSH_PARTNER_SUP_VIEW')" style="margin: 0px; white-space: nowrap" @click="detailItem(data.item)">
                          {{ data.item.phoneNo }}
                        </p>
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
              <div class="row d-flex justify-content-end mr-3">
                <div>
                  <b-pagination @change="changeCurrentPage" hide-goto-end-buttons v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"></b-pagination>
                </div>
              </div>
            </div>

            <div class="box-loading" v-if="loading">
              <div class="loading">
                <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Modal import-->
      <b-modal id="modal-scoped" v-model="modalImport" no-close-on-backdrop>
        <template #modal-header>
          <h4 class="title-modal-custom mb-0">Nhập danh sách nhà cung cấp</h4>
          <button type="button" aria-label="Close" class="close" @click="cancels">
            <i class="el-icon-close"></i>
          </button>
        </template>
        <template #default>
          <ul class="dotUL ml-4">
            <li>Tải file mẫu <a href="/assets/files/ReportSuppliers.xlsx">tại đây</a> (Cập nhật ngày 22/12/2021)</li>
            <li>File có định dạng .XLSX và giới hạn 3000 dòng</li>
          </ul>
          <label class="step-content" tabindex="0" for="file">
            <div class="input-file-containers">
              <input class="input-file" style="display: none" id="file" @change="uploadFileExcel" ref="file" type="file" accept=".xlsx,.xls,.csv" />
              <p v-if="messFailFormat" class="color-red"><i class="bx bxs-cloud-upload mr-2"></i> {{ messFailFormat }}</p>
              <p v-if="keyCheckUpload == 0 && messFailFormat == ''"><i class="bx bxs-cloud-upload mr-2"></i> Bấm vào đây để tải lên từ thiết bị</p>
              <p v-if="keyCheckUpload == 1" class="text-bold text-dark"><i class="bx bxs-cloud-upload mr-2"></i> File: {{ fileName }}</p>
            </div>
          </label>
        </template>

        <template #modal-footer="{}">
          <div class="d-flex justify-content-between w-100 m-0">
            <b-button variant="danger" size="md" class="m-0" @click="cancels()">Hủy </b-button>
            <b-button variant="primary" size="md" class="m-0" v-if="isUpload"><i class="fas fa-spinner fa-spin"></i> Đang tải</b-button>
            <b-button variant="primary" size="md" class="m-0" v-if="!isUpload" @click="importData">Hoàn tất</b-button>
          </div>
        </template>
      </b-modal>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>
<script>
import Swal from "sweetalert2";
import { SupplierServices } from "@/services/nextshop/supplier.service";
import { CustomerServices } from "@/services/nextshop/customer.service";
import _ from "lodash";

export default {
  page: {
    title: "Danh sách nhà cung cấp",
  },
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
      title: "DANH SÁCH NHÀ CUNG CẤP",
      isShow: true,
      loading: false,
      items: [],
      tab: 0,
      optionsPerPage: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 30, text: "30" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      // tabs: [
      //   { tab: "Tất cả", isPerson: 2 },
      //   { tab: "Doanh nghiệp", isPerson: 0 },
      //   { tab: "Cá nhân", isPerson: 1 },
      // ],
      fields: [
        { key: "selected", label: "", thStyle: { width: "1%" } },
        { key: "name", label: "Họ tên", thStyle: { width: "10%" } },
        { key: "group", label: "Nhóm nhà cung cấp", thStyle: { width: "10%" } },
        { key: "isPerson", label: "Phân loại", thStyle: { width: "10%" } },
        { key: "phoneNo", label: "Số điện thoại", thStyle: { width: "10%" } },
        // { key: "manipulation", label: "", tdClass: "text-right", thStyle: { width: "5%" } },
      ],
      dataSupplier: [],
      dataSupplierIndividual: [],
      dataSupplierCompany: [],
      selected: [],
      textSearch: "",
      search: {
        query: "",
        merchantId: JSON.parse(localStorage.getItem("auth.currentUser")).merchantId,
        person: 2,
        sort: "date",
      },
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      filter: "",
      filterOn: [],
      modalImport: false,
      formData: null,
      messFailFormat: "",
      keyCheckUpload: 0,
      fileName: "",
      isUpload: false,
      activeTab: "2",
      showFilter: false,
      test: "",
      selectAll: false,
      loadingSelect: false,
      groupNCCid: "",
      optionsGroupNCC: [],
      isPerson: null,
      optionsIsPerson: [
        {
          text: "Cá nhân",
          value: true,
        },
        {
          text: "Doanh nghiệp",
          value: false,
        },
      ],
      textSearchNCC: "",
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    changeCurrentPage(num) {
      this.currentPage = num;
      this.fetchData();
    },
    debounceInput: _.debounce(function(e) {
      this.fetchData(e);
    }, 300),
    //Get data
    async fetchData() {
      this.selected = [];
      this.selectAll = false;
      const text = this.textSearchNCC.trim();
      const params = {
        textSearch: text,
        typePartner: "SUPPLIER",
        pageNum: this.currentPage,
        pageSize: 10,
        sortBy: "_id",
        sortType: "DESC",
        ...(this.isPerson !== null && { isPerson: this.isPerson }),
        // ...(text && { name: text }),
        // ...(text && { phoneNo: text }),
        ...(this.groupNCCid && {
          groupList: [this.groupNCCid],
        }),
      };

      try {
        // return;
        this.loading = true;
        const response = await CustomerServices.getListCustomerPagging(params);
        console.log(123, response);
        if (response.success) {
          this.dataSupplier = response.data.data;
          this.totalRows = response.data.totalElements;
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.isShow = true;
      }
    },
    async fetchDataNEW() {
      this.selected = [];
      this.selectAll = false;
      const text = this.textSearchNCC.trim();
      const params = {
        query: text,
        merchantId: this.inforAccount.merchantId,
        person: 2,
        page: 1,
        limit: 10,
      };

      try {
        // return;
        this.loading = true;
        const response = await SupplierServices.getListSupplier(params);
        console.log(123, response);
        if (response.success) {
          this.dataSupplier = response.data.data;
          this.totalRows = response.data.totalElements;
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.isShow = true;
      }
    },

    focusNCC() {
      this.getListGroupNCC()
    },

    async getListGroupNCC(query) {
      if (query !== "") {
        this.loadingSelect = true;
        try {
          const response = await SupplierServices.groupsSearch({
            merchantId: this.inforAccount.merchantId,
            name: query,
            typePartner: "SUPPLIER",
            page: this.currentPage,
            limit: 20,
            sortBy: "_id",
            sortType: "DESC",
          });
          this.optionsGroupNCC = response.data.data;
        } catch (error) {
          console.log(error);
        } finally {
          this.loadingSelect = false;
        }
      } else {
        this.options = [];
      }
    },
    //Delete item
    deleteItem(data) {
      Swal.fire({
        title: "Xóa thông tin",
        text: data.length > 1 ? `Bạn có chắc muốn xóa thông tin nhiều nhà cung cấp ?` : `Bạn có chắc muốn xóa thông tin nhà cung cấp ?`,
        icon: "warning",
        confirmButtonText: "Xác nhận",
      }).then((result) => {
        if (result.value) {
          this.deleteSupplier(data);
        }
      });
    },
    async deleteSupplier(data) {
      this.loading = true;
      const params = this.selected.map((e) => {
        return e.id;
      });
      try {
        const response =
          data.length > 1
            ? await SupplierServices.deleteSupplier({
                merchantId: this.inforAccount.merchantId,
                partnerIds: params,
              })
            : await SupplierServices.deleteSupplier({
                merchantId: this.inforAccount.merchantId,
                partnerIds: [data.id],
              });
        if (response.success) {
          this.deletemsg();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    deletemsg() {
      Swal.fire({
        title: "Thành công",
        text: `Đã cập nhật thông tin thành công!`,
        icon: "success",
        confirmButtonText: "Xác nhận",
      }).then((result) => {
        if (result.value) {
          this.fetchData();
        }
      });
    },
    //Edit item
    editItem(data) {
      this.$router.push({ path: `/supplier-list/supplier-edit/${data.id}` });
    },
    //Get detail
    detailItem(data) {
      this.$router.push({ path: `/supplier-list/supplier-detail/${data.id}` });
    },
    //Search item
    // clickSearch() {
    //   this.search.query = this.textSearch.split(" ").join("");
    //   this.fetchData();
    // },
    // Change tab
    changeTab(tab) {
      this.search.person = parseInt(tab.name);
      this.selected = [];
      this.fetchData();
    },
    remove() {
      this.filter = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async exportData() {
      try {
        const params = {
          merchantId: this.search.merchantId,
          person: this.search.person,
        };
        this.loading = true;
        const response = await SupplierServices.exportData(params);
        if (response.status == 200) {
          Swal.fire({
            title: "Xuất dữ liệu thành công",
            text: `Dữ liệu danh sách nhà cung cấp sẽ được tải về thiết bị của bạn`,
            icon: "success",
            confirmButtonText: "Xác nhận",
          }).then((result) => {
            if (result.value) {
              this.fetchData();
            }
          });
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async uploadFileExcel() {
      const allowedExtensions = /(\.xls|\.xlsx|\.csv)$/i;
      const checkFomat = allowedExtensions.exec(this.$refs.file.value);

      this.fileName = this.$refs.file.files[0].name;
      this.messFailFormat = "";
      this.formData = new FormData();
      this.formData.append("file", this.$refs.file.files[0]);
      this.formData.append("merchantId", this.search.merchantId);

      if (!checkFomat) {
        this.keyCheckUpload = 2;
        this.messFailFormat = "Định dạng không hợp lệ !";
        this.fileName = "";
      } else {
        this.keyCheckUpload = 1;
      }
    },

    async importData() {
      try {
        if (this.formData === null) {
          this.messFailFormat = "Vui lòng chọn file tải lên !";
          return false;
        }
        this.isUpload = true;
        const response = await SupplierServices.importData(this.formData);

        let _title = "";
        let _icon = "";
        if (response.success == false) {
          _title = "Nhập dữ liệu lỗi";
          _icon = "error";
        } else {
          _title = "Nhập dữ liệu thành công";
          _icon = "success";
        }

        if (response.status == 200) {
          this.isUpload = false;
          Swal.fire({
            title: _title,
            text: response.data.data.message,
            icon: _icon,
            confirmButtonText: "Xác nhận",
            closeOnClickOutside: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.value) {
              this.fetchData();
              this.cancels();
            }
          });
        }
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    cancels() {
      this.fileName = "";
      this.keyCheckUpload = 0;
      this.messFailFormat = "";
      this.formData = null;
      this.modalImport = false;
    },
    resetFilter() {
      this.isPerson = null;
      this.groupNCCid = "";
      this.fetchData();
    },
    searchItem() {
      this.showFilter = false
      this.fetchData();
    },
  },
  watch: {
    selectAll(val) {
      this.selected = [];
      // console.log(this)
      // return
      if (val) {
        this.dataSupplier.forEach((item) => {
          this.selected.push(item);
        });
      }
    },
    textSearchNCC: _.debounce(function() {
      if (this.textSearchNCC == "") this.fetchData();
    },700)
  },
};
</script>
<style lang="scss">
  .search-input input{
    height: 44px;
  }
</style>

<style lang="scss" scoped>
.dotUL {
  li {
    margin-bottom: 8px;
    list-style-type: disc;
  }
}
.step-content {
  text-align: center;
  border: 2px dashed #ced4da;
  padding: 80px 0;
  margin: 20px 0 0;
  width: 100%;
  cursor: pointer;
}
.input-file-containers {
  font-size: 14px;
  color: #ced4da;
  cursor: pointer;
}
.input-file-containers .bxs-cloud-upload {
  font-size: 20px;
  position: relative;
  top: 3px;
  cursor: pointer;
}
.btn-outline-info {
  color: #3e69f6;
  border: 1px solid #3e69f6;
}
.btn-outline-info:hover {
  color: #3e69f6;
  background: #fff !important;
}

// moi

.empty_box {
  .empty_title {
    font-weight: 600;
    font-size: 24px;
    color: #23313e;
  }

  .empty_sub {
    font-weight: 400;
    font-size: 14px;
    color: #808890;
  }
}
</style>
